module.exports = __webpack_public_path__ + "img/g6.5cc7f947.jpg";